<template>
  <div class="row mb-5">
    <div class="upperSidebar" v-if="categories">
      <ul class="upperSidebar__list">
        <UpperSidebarLink :route-name="summaryPageName" name="Summary" />
        <span v-for="(category, index) in categories" v-bind:key="index">
          <UpperSidebarLink :route-name="routePrefix + category.name" :name="category.name" :category="category" />
        </span>
      </ul>
    </div>
  </div>
</template>

<script>
import UpperSidebarLink from './UpperSidebarLink';
import CategoryController from '@/controllers/Category/CategoryController';
export default {
  name: 'UpperSidebar',
  components: { UpperSidebarLink },
  props: {
    prop_categories: Array,
    summaryPageName: String,
    routePrefix: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      categories: null,
    };
  },
  async mounted() {
    this.categories = await this.getCategories();
  },
  methods: {
    async getCategories() {
      if (this.prop_categories) {
        return this.prop_categories;
      } else {
        return await this.fetchCategories();
      }
    },
    async fetchCategories() {
      let categories = await this.$store.dispatch('refreshCategories');
      if (categories) {
        return this.sortCategories(categories);
      } else {
        return {};
      }
    },
    sortCategories(categories) {
      let filtered_categories = categories.filter(function (category) {
        if (category.name === 'education and policies') category.name = 'policies';
        return (
          category.name === 'water' ||
          category.name === 'air' ||
          category.name === 'environment' ||
          category.name === 'policies' ||
          category.name === 'energy' ||
          category.name === 'waste'
        );
      });
      return filtered_categories.sort(function (category_1, category_2) {
        return category_2.name - category_1.name;
      });
    },
  },
};
</script>

<style scoped></style>
